import { HttpContextToken } from '@angular/common/http';

/**
 * Context token used to signal that the AddTenantHeaderInterceptor should
 * not append the Active-Tenant-Identifier header for the request.
 */
export const SKIP_TENANT_HEADER = new HttpContextToken<boolean>(() => false);
